import React, { useEffect, useState, useRef } from "react";
import Tables from "./Tables";
import Tab from "./Tab";
import ArrowLeft from "../../common/images-new/arrow-left-blue-icon.svg"
import ArrowRight from "../../common/images-new/arrow-right-blue-icon.svg"
import { ActiveIconColor, BgWhite, TextGray } from "../Theme";
import Toggle from "../../components/Button/Toggle";
import { IoMdLock } from 'react-icons/io'
import { MdKeyboardArrowRight } from "react-icons/md";

const EditValueComp = ({ data, compentencyStatus, setcompentencyStatus, isHide }) => {
    const ref = useRef()

    const scroll = (scrollOffset) => {
        ref.current.scrollLeft += scrollOffset;
    }

    const [currentPage, setCurrentPage] = useState(0)

    const [tabNames, setTabNames] = useState([])
    const [tabData, setTabData] = useState([])
    const [showVC, setShowVC] = useState(false)

    useEffect(() => {
        if (data && (data.length > 0)) {
            setTabNames(data.map(valGroup => valGroup.name))
            setTabData(data[currentPage].children)
        }
    }, [data, currentPage])

    const handleChange = () => {
        setcompentencyStatus(!compentencyStatus)
    }

    return (
        <BgWhite className="flex flex-col bg-white items-center pt-10 pb-5">
                <div className="flex flex-row space-x-3 items-center pb-5">
                    {!isHide && showVC === false && <IoMdLock className='w-6 h-6' />}
                    <p className="font-bold text-center md:text-2xl ">My Values and Competencies</p>
                    <Toggle checked={compentencyStatus} onChange={() => handleChange()} />
                </div>


            {
                (tabNames.length > 0) ?
                    <>
                        <Tab tabs={tabNames} page={currentPage} setPage={setCurrentPage} />

                        <div className="flex flex-row justify-center items-center md:space-x-2 px-12 xl:px-16 w-screen relative">

                            <div className="flex item-center cursor-pointer hover:opacity-80 absolute left-5 lg:left-10">
                                <ActiveIconColor>
                                    <MdKeyboardArrowRight className="hover:opacity-50 cursor-pointer w-8 h-8" onClick={() => scroll(-300)} />
                                </ActiveIconColor>
                                {/* <img src={ArrowLeft} alt="arrow left" onClick={() => scroll(-300)}></img> */}
                            </div>

                            <div className="xl:mb-5 overflow-x-auto no-scrollbar" ref={ref}>
                                <Tables data={tabData} />
                            </div>

                            <div className="flex item-center cursor-pointer hover:opacity-80 absolute right-5 lg:right-10">
                                <ActiveIconColor>
                                    <MdKeyboardArrowRight className="hover:opacity-50 cursor-pointer w-8 h-8" onClick={() => scroll(300)} />
                                </ActiveIconColor>
                                {/* <img src={ArrowRight} alt="arrow right" onClick={() => scroll(300)}></img> */}
                            </div>
                        </div>
                    </>
                    :
                    (!isHide && <TextGray className="italic">Competency is not defined</TextGray>)
            }
        </BgWhite>


    )
}

export default EditValueComp
